<wms-dialog-header (onClose)="closeModal()"
    title='{{locale[baseVariableService.dialogHeaderKey] + ": " + pageWsService.activePageName + " " + locale.LABEL_PAGE}}'
    helpTitle="{{locale.LABEL_WEB_SERVICE}}"
    helpLink="https://www.wavemaker.com/learn/app-development/variables/data-integration/">
</wms-dialog-header>

<wms-dialog-body>
    <div class="secondary-panel" style="width:100%;">
        <wms-message *ngIf="varManagerService.addVariableDialogMsg" customClass="mg-5" [scopeDataset]="varManagerService.addVariableDialogMsg"></wms-message>
        <div class="wm-variable-content-form">
            <!-- service selection screen -->
            <div class="wm-variable-creation-tiles" *ngIf="stepCount === 1" style="height:100%;">
                <h4 class="sub-heading">{{locale[serviceSelectionHeading]}}</h4>
                <ul class="list-inline padded-container wm-tile-list select-template-list list-templates text-left category-section"
                    *ngFor="let serviceTypeGroup of serviceTypeGroups">
                    <h6>{{locale.LABEL_VARIABLE_SERVICETYPE_GROUP[serviceTypeGroup.id]}}</h6>
                    <!-- TODO: title="{{template.title}}" -->
                    <li class="tile" *ngFor="let serviceType of serviceTypeGroup.serviceTypes"
                        (click)="hoveredServiceType = undefined; onServiceSelection(serviceType)"
                        (mouseover)="hoveredServiceType = serviceType"
                        [ngClass]="{active: selectedServiceType === serviceType}">
                        <div class="wm-tile-thumbnail-ctr {{serviceType}}">
                            <i class="wms wms-v-{{serviceType}}-service"></i>
                        </div>
                        <p class="wm-tile-name">{{locale.LABEL_VARIABLE_SERVICETYPE[serviceType]}}</p>
                    </li>
                </ul>
            </div>
            <!-- config properties -->
            <div class="category-section"
                *ngIf="stepCount > 1 && (selectedServiceType == 'databaseapi' || selectedServiceType == 'web' || selectedServiceType == 'openapi')">
                <wms-imported-api-var-creation *ngIf="selectedServiceType === 'openapi'"
                    [selectedServiceType]="selectedServiceType"
                    [selectedVarService]="variableCreationServices.get('openapi')">
                </wms-imported-api-var-creation>

                <wms-database-api-var-creation *ngIf="selectedServiceType === 'databaseapi'"
                    [selectedServiceType]="selectedServiceType"
                    [selectedVarService]="variableCreationServices.get('databaseapi')">
                </wms-database-api-var-creation>

                <wms-webservice-var-creation *ngIf="selectedServiceType === 'web'"
                    [selectedServiceType]="selectedServiceType"
                    [selectedVarService]="variableCreationServices.get('web')">
                </wms-webservice-var-creation>

            </div>

            <!-- Primary Properties -->
            <div class="category-section"
                *ngIf="baseVariableService.selectedVariable?.category && varManagerService.showPrimaryProps && stepCount > 1">
                <ul class="primary-properties one-col"
                    *ngIf="(selectedServiceType != 'databaseapi' && selectedServiceType != 'web' && selectedServiceType != 'openapi')">
                    <wms-database-var-creation *ngIf="selectedServiceType === 'database'"
                        [selectedVarService]="selectedVarService"></wms-database-var-creation>
                    <wms-javaservice-var-creation *ngIf="selectedServiceType === 'java'"
                        [selectedVarService]="selectedVarService"></wms-javaservice-var-creation>
                    <wms-securityservice-var-creation *ngIf="selectedServiceType === 'security'"
                     [selectedVarService]="selectedVarService">
                    </wms-securityservice-var-creation>
                    <wms-device-var-creation *ngIf="selectedServiceType === 'device'"
                    [selectedVarService]="selectedVarService"></wms-device-var-creation>
                    <wms-navigation-action-creation *ngIf="selectedServiceType === 'navigation'"
                     [selectedVarService]="selectedVarService">
                    </wms-navigation-action-creation>
                    <wms-notification-action-creation *ngIf="selectedServiceType === 'notification'"
                        [selectedVarService]="selectedVarService"></wms-notification-action-creation>
                </ul>
                <!-- Method field -->
                <div *ngIf="(selectedServiceType === 'openapi' || selectedServiceType === 'web' || selectedServiceType === 'java' || selectedServiceType === 'security') && baseVariableService.selectedVariable?.propertyObj['operation']?.isprimary &&
                    !(baseVariableService.selectedVariable.propertyObj['operation'].editonly && baseVariableService.createOnly) && !baseVariableService.selectedVariable.propertyObj['operation'].hide"
                    class="form-group app-composite-widget clearfix">
                    <label class="control-label app-label col-xs-3 required"
                        title="{{locale['LABEL_VARIABLE_PROPERTIES_'+'operation'.toUpperCase()] || 'operation'}}">
                        {{locale.LABEL_PROPERTY_METHOD}}
                    </label>
                    <wms-variables-template style="display: inline-block;"
                        (onModelChange)="handleModelChange($event)" [editable]="selectedServiceType==='java'"
                        [templateType]="'var-prop-' + ( baseVariableService.selectedVariable.propertyObj['operation']['widgettype'] ||  baseVariableService.selectedVariable.propertyObj['operation']['type'] || 'string')"
                        propertyName="operation" [selectedVariable]="baseVariableService.selectedVariable"
                        [selectedService]="selectedVarService"></wms-variables-template>
                        <i class="wms wms-help" container="body"
                        tooltip="{{locale['MESSAGE_HELP_VARIABLE']['operation'.toUpperCase()]}}" placement="right"></i>
                </div>

                <!-- Select query field -->
                <div *ngIf="selectedServiceType === 'databaseapi' && varManagerService.initVariableObj.values.target === 'query' && baseVariableService.selectedVariable?.propertyObj['operation']?.isprimary &&
                !(baseVariableService.selectedVariable.propertyObj['operation'].editonly && baseVariableService.createOnly) && !baseVariableService.selectedVariable.propertyObj['operation'].hide"
                class="form-group app-composite-widget clearfix">
                <label class="control-label app-label col-xs-3 required"
                    title="{{locale['LABEL_VARIABLE_PROPERTIES_'+'operation'.toUpperCase()] || 'operation'}}">
                    {{locale.LABEL_VARIABLE_SELECT_QUERY}}
                </label>
                <wms-variables-template style="display: inline-block;"
                    (onModelChange)="handleModelChange($event)"
                    [templateType]="'var-prop-' + ( baseVariableService.selectedVariable.propertyObj['operation']['widgettype'] ||  baseVariableService.selectedVariable.propertyObj['operation']['type'] || 'string')"
                    propertyName="operation" [selectedVariable]="baseVariableService.selectedVariable"
                    [selectedService]="selectedVarService"></wms-variables-template>
                    <i class="wms wms-help" container="body"
                    tooltip="{{locale['MESSAGE_HELP_VARIABLE']['operation'.toUpperCase()]}}" placement="right"></i>
                </div>

                <!-- Select procedure field -->
                <div *ngIf="selectedServiceType === 'databaseapi' && varManagerService.initVariableObj.values.target === 'procedure' && baseVariableService.selectedVariable?.propertyObj['operation']?.isprimary &&
                    !(baseVariableService.selectedVariable.propertyObj['operation'].editonly && baseVariableService.createOnly) && !baseVariableService.selectedVariable.propertyObj['operation'].hide"
                    class="form-group app-composite-widget clearfix">
                    <label class="control-label app-label col-xs-3 required"
                        title="{{locale['LABEL_VARIABLE_PROPERTIES_'+'operation'.toUpperCase()] || 'operation'}}">
                        {{locale.LABEL_VARIABLE_SELECT_PROCEDURE}}
                    </label>
                    <wms-variables-template style="display: inline-block;"
                        (onModelChange)="handleModelChange($event)"
                        [templateType]="'var-prop-' + ( baseVariableService.selectedVariable.propertyObj['operation']['widgettype'] ||  baseVariableService.selectedVariable.propertyObj['operation']['type'] || 'string')"
                        propertyName="operation" [selectedVariable]="baseVariableService.selectedVariable"
                        [selectedService]="selectedVarService"></wms-variables-template>
                        <i class="wms wms-help" container="body"
                        tooltip="{{locale['MESSAGE_HELP_VARIABLE']['operation'.toUpperCase()]}}" placement="right"></i>
                </div>

                <!-- variable name -->
                <div class="form-group app-composite-widget clearfix">
                    <label class="col-md-3 app-label required">{{locale.LABEL_VARIABLE_PROPERTIES_NAME}}</label>
                    <input type="text" class="form-control app-textbox" id="wm-addvariable-property-name" name="wm-addvariable-property-name"
                        [(ngModel)]="varManagerService.variableNameProxy"
                        (change)="varManagerService.changeVariableName(varManagerService.variableNameProxy)"
                        placeholder="{{locale.LABEL_INSERT_VARIABLE_PLACEHOLDER}}" maxlength="50"
                        (ngModelOptions)="{allowInvalid: true, updateOn: 'blur'}">

                    <i class="wms wms-help" container="body" tooltip="{{locale['MESSAGE_HELP_VARIABLE_NAME']}}"
                        placement="right"></i>
                </div>
                <!-- variable owner -->
                <div class="form-group app-composite-widget clearfix">
                    <label class="col-md-3 app-label required">{{locale.LABEL_VARIABLE_PROPERTIES_OWNER}}</label>
                    <select class="form-control app-select" name="wm-addvariable-property-owner"
                        [(ngModel)]="varManagerService.variableOwnerProxy"
                        (change)="varManagerService.changeVariableOwner()">
                        <option
                            *ngFor="let option of baseVariableService.selectedVariable?.propertyObj.owner.options | keyvalue"
                            [value]="option.key">{{locale[$any(option.value)]}}</option>
                    </select>
                    <i class="wms wms-help" container="body" tooltip="{{locale['MESSAGE_HELP_VARIABLE_OWNER']}}"
                        placement="right"></i>
                </div>
                <wms-variable-tab-view [disableBinding]="disableBinding" *ngIf="selectedServiceType === 'custom' || selectedServiceType === 'timer' || selectedServiceType === 'login'"></wms-variable-tab-view>
            </div>

        </div>
    </div>
</wms-dialog-body>
<wms-dialog-footer>
    <span class="pull-left">{{locale.MSG_VARIABLE_SERVICE_TYPE_HELP[hoveredServiceType]}}</span>
    <button name="wm-addvariable-cancel" (click)="closeModal()" [disabled]="baseVariableService.disableDialogActions"
        class="button-secondary btn app-button">{{locale.LABEL_CANCEL}}</button>
    <button name="wm-addvariable-back"  [disabled]="baseVariableService.disableDialogActions" *ngIf="varManagerService.selectedVariableCategory" (click)="back()"
        class="button-tertiary btn app-button">{{locale.LABEL_BACK}}</button>
    <button name="wm-addvariable-save_close"  [disabled]="baseVariableService.disableDialogActions" *ngIf="varManagerService.selectedVariableCategory" (click)="varManagerService.saveAndClose()"
        class="button-primary btn app-button">{{locale.LABEL_DONE}}</button>
</wms-dialog-footer>
